export default __webpack_public_path__ + "43567f6a82152e4323e707c5f18f47df.png";